import { render, staticRenderFns } from "./WordsFieldForm.vue?vue&type=template&id=2b2a4923&scoped=true&lang=pug&"
import script from "./WordsFieldForm.vue?vue&type=script&lang=js&"
export * from "./WordsFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./WordsFieldForm.vue?vue&type=style&index=0&id=2b2a4923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a4923",
  null
  
)

export default component.exports